import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller.ts'

export type ParentEligibilityForm = {
  insurance_parent_member_id: string
}

export default class FormParentEligibilityController extends Controller {
  declare insuranceParentMemberIdTarget: HTMLInputElement
  static targets = ['insuranceParentMemberId']

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    this.insuranceParentMemberIdTarget.focus()
    this.setInitialValues()
    this.checkoutOutlet.onPage2()
  }

  setInitialValues() {
    if (!this.checkoutOutlet.parentEligibilityForm) return
    const { insurance_parent_member_id } =
      this.checkoutOutlet.parentEligibilityForm

    this.insuranceParentMemberIdTarget.value = insurance_parent_member_id
  }

  submit(event: SubmitEvent) {
    if (!event.target) throw new Error('Missing event target')

    const formData = new FormData(event.target as HTMLFormElement)
    const parentEligibilityForm: ParentEligibilityForm = {
      insurance_parent_member_id: formData.get(
        'insurance_parent_member_id',
      ) as string,
    }

    this.checkoutOutlet.setParentEligibilityForm(parentEligibilityForm)
  }
}
